import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './postcode_scss/main.scss';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { Provider } from 'react-redux';
import configureStore from './store';
const store = configureStore;

ReactDOM.render(
  <Provider store={store}>
    <ToastContainer position='bottom-left' autoClose={4000} />
    <App />
  </Provider>,
  document.getElementById('root')
);
